import { Button } from "@/components/button";
import { FONT } from "@/styles/common";
import { Box } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomButton = styled(Button)`
    position: relative;
    z-index: 3;
    ${FONT("cormorant", 16, 700)}
    color: ${({ theme }) => theme.COLOR.white};
    background: ${({ theme }) => theme.COLOR.black};
    transition: 1s cubic-bezier(0.215, 0.61, 0.355, 1);

    &.on {
        color: ${({ theme }) => theme.COLOR.black};
        background: ${({ theme }) => theme.COLOR.white};
    }

    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        width: 32px;
        height: 32px;
        padding: 0;
    }
`;

export const CustomToggleBox = styled(Box)`
    position: absolute;
    box-sizing: border-box;
    padding: 100px 0;
    z-index: 2;
    width: 100%;
    height: 100vh;
    top: -100vh;
    left: 0;
    transition: 1s cubic-bezier(0.215, 0.61, 0.355, 1);
    background: rgba(0, 0, 0, 0.9);

    &.on {
        top: 0;
    }
`;
